<template>
	<v-dialog v-model="open"
		max-width="800px"
		height="390"
		content-class="rounded-xl"

	>
		<v-card class="bg" max-width="800px"
			height="400"
		>
			<v-col class="pt-8"></v-col>
			<v-toolbar-title class="assistant text-center title pt-16">{{$t('generics.hello')}} {{user.name}}</v-toolbar-title>
			<v-toolbar-title class="assistant text-center title">{{$t('pages.popup.upgrade.line1')}}</v-toolbar-title>
			<v-toolbar-title class="assistant text-center title">{{$t('pages.popup.upgrade.line2')}}</v-toolbar-title>
			<v-toolbar-title class="assistant text-center title">{{$t('pages.popup.upgrade.line3')}}</v-toolbar-title>
			<v-card-text class="mt-4">
				<v-btn @click="open = !open" :to="{name:'plans-page'}" color="#FA6655" class="white--text">{{$t('pages.popup.upgrade.sub')}}</v-btn>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "UpgradeDialog",
	props: { value: Boolean },
	computed: {
		open: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		user () {
			return this.$store.state.AuthModule.user;
		},
	},
	methods: {
	},
};
</script>

<style scoped>
.bg{
  background: url('../../../public/img/bg_popup.png');
  background-position: center center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  border-radius: 30px;
  text-align: center;
  color:#374D8F;
}


</style>
